import React from 'react'
import {
  AccordionPanel as ChakraAccordionPanel,
  AccordionPanelProps,
} from '@chakra-ui/react'

export const AccordionPanel: React.FC<
  React.PropsWithChildren<Pick<AccordionPanelProps, 'as' | 'sx' | 'children'>>
> = props => <ChakraAccordionPanel {...props} />
